import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchGeneralSettingsData } from '../features/settings/generalSettingsSlice';

const BottomFooter = () => {
    const dispatch = useDispatch();
    const {loading, generalSettings, error} = useSelector(state => state.generalSettings)
    
    useEffect(() => {
        dispatch(fetchGeneralSettingsData())
    }, [dispatch])

    return (
        <div className="bottom-footer bg-color-one py-8">
            <div className="container container-lg">
                <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16">
                    <p className="bottom-footer__text ">
                        {generalSettings?.general_setting?.footer_copy_right?.en}
                    </p>
                </div>
            </div>
        </div>

    )
}

export default BottomFooter